import cx from 'classnames'

export const FormActions = ({ children, className, ...props }) => (
  <div className={cx('tw:flex tw:items-center tw:justify-end tw:gap-2 tw:compact:[&>button]:flex-1', className)} {...props}>
    {children}
  </div>
)
